import { ValidationFailure } from 'generated/mos/org/getty/validation'
import { Schema } from 'helpers/schema'

export const IssueMesages: {[key in ValidationFailure.Issue.IssueType]: string | undefined} = {
  'NO_ISSUE': undefined,
  'MISSING_REQUIRED_ATTRIBUTE': 'Required to publish',
  'TOUR_CONTAINS_NO_STOPS': 'Tour contains no stops',
  'TOUR_CONTAINS_STOPS_FROM_MULTIPLE_SITES': 'Tour contains stops from multiple sites',
  'TOUR_CATEGORY_CONTAINS_TOURS_FROM_MULTIPLE_SITES': 'Tour category contains stops from multiple sites',
  'TOUR_CONTAINS_STOPS_AND_HAS_WEBPAGE_URL': 'Tour contains stops and has a webpage URL',
  'INVALID_COLOR': 'Invalid color',
  'MISSING_TMS_OBJECT': 'The associated TMS Object has been deleted from MOS',
}

export const getValidationWarning = <TEntity>(key: keyof Schema<TEntity>, failureFields: ReadonlyArray<ValidationFailure.Issue.Entity> | undefined) => {
  const field = failureFields && failureFields.find(({ attributeName }) => key === attributeName)
  return field && IssueMesages[field.issueType]
}
